import axios from "axios";
import { BACKEND_URL } from "./constants";
import { toast } from "react-toastify";

const authHeader = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return { Authorization: "Bearer " + token };
  }
  return {};
};

const createAxiosInstance = (history = null) => {
  const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers: authHeader(),
  });

  // Always attach the latest token before each request
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      } else if (config.headers && config.headers.Authorization) {
        delete config.headers.Authorization;
      }
      return config;
    },
    (requestError) => Promise.reject(requestError),
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 502 || status === 401 || status === 403) {
          toast.error(
            error?.response?.data?.error || "You are not authorized to access",
            { toastId: "error" },
          );
          setTimeout(() => {
            localStorage.clear();
            if (history) {
              history.push("/login");
            } else {
              window.location.href = "/login";
            }
          }, 1500);
        }
      } else {
        console.error("Network/Unknown error:", error.message);
      }

      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export default createAxiosInstance;
